import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {Typography} from "@material-ui/core";
import Button from "@material-ui/core/Button";

const StyledTableCell = withStyles((theme) => ({
    // head: {
    //     backgroundColor: theme.palette.primary.main,
    //     color: theme.palette.common.white,
    // },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(site,  chat1day, chat7day, chat15day, chat30day, mail1day, mail7day,  mail15day, mail30day) {
    return { site,  chat1day, chat7day, chat15day, chat30day, mail1day, mail7day,  mail15day, mail30day };
}

let sites = {
    SvadbaChat: false,
    ZolushkaChat: false,
    ZolushkaMail: false,
    RomanceChat: false,
    RomanceMail: false,
    JumpChat: false,
    JumpMail: false,
    DreamChat: false,
    DreamMail: false,
    DreamFlirt: false,
    CharmDateChat: false,
    CharmDateMail: false,
    CharmDateADMMail: false,
    LyubimayaMail: false,
    HanumaChat: false,
    HanumaMail: false,
    MariyaClubChat: false,
    MariyaClubMail: false,
    MarriagencyMail: false,
    ForeignLadiesAdmin: false,
    StarMarriageMail: false,
    GlobalCompanionsChat: false,
    HabibiChat: false,
    FineBrideChat: false,
    FineBrideMail: false,
    SvadbaMail: false,
    PrimeChat: false,
    LadadateChat: false,
    LovemeMail: false,
    VictoriyaclubChat: false,
    VictoriyaclubMail: false,
    NatashaclubMail: false,
    BridgeofloveChat: false,
    PrimeMail: false,
    SmartprogrammMail: false,
    MyeasypartnerMail: false,
}



/*
SvadbaChat: false,
ZolushkaChat: false,
ZolushkaMail: false,
RomanceChat: false,
RomanceMail: false,
JumpChat: false,
JumpMail: false,
DreamChat: false,
DreamMail: false,
DreamFlirt: false,
CharmDateChat: false,
CharmDateMail: false,
CharmDateADMMail: false,
LyubimayaMail: false,
HanumaChat: false,
HanumaMail: false,
MariyaClubChat: false,
MariyaClubMail: false,
MarriagencyMail: false,
ForeignLadiesAdmin: false,
Star MarriageMail: false,
GlobalCompanionsChat: false,
HabibiChat: false,
FineBrideChat: false,
FineBrideMail: false,

Svadba Chat
Zolushka Chat
Zolushka Mail
Romance Chat
Romance Mail
Jump Chat
Jump Mail
Dream Chat
Dream Mail
Dream Flirt
CharmDate Chat
CharmDate Mail
CharmDateADM Mail
Lyubimaya Mail
Hanuma Chat
Hanuma Mail
MariyaClub Chat
MariyaClub Mail
Marriagency Mail
ForeignLadies Admin
Star Marriage Mail
GlobalCompanions Chat
Habibi Chat
Fine Bride Chat
Fine Bride Mail


 */

const useStyles = makeStyles({
    table: {
        minWidth: 700,
    },
});

export default function CustomizedTables(props) {
    const classes = useStyles();
    //let { discounts } = props;
    //let a = {};
    // discounts.map(el => a[el.site.alias.replace(' ', '')] = el.discount_percent);
    // sites = {...sites, ...a};
    const rows = [
        createData('Romance', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        createData('J4L', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        createData('CharmDate', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        createData('Victoriyaclub', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        createData('Svadba', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        createData('NatashaClub', '-', '-', '-', '-', 5.7, 38, 68, 120),
        createData('LadaDate', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        
        createData('Bridge of love', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        createData('Hanuma', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        createData('Loveme', '-', '-', '-', '-', 9, 60, 120, 225),
        createData('MariyaClub', 9, 60, 120, 225, 9, 60, 120, 225),
        createData('Foreignladies', '-', '-', '-', '-', 9, 60, 120, 225),
        createData('Goldenbride', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        createData('dream-singles', 5.7, 38, 68, 120, 5.7, 38, 68, 120),

        createData('MarriagencyMail', '-', '-', '-', '-', 5.7, 38, 68, 120),
        createData('Generationlove', '-', '-', '-', '-', 5.7, 38, 68, 120),
        createData('Findbride', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        createData('Udate', 9, 60, 120, 225, 9, 60, 120, 225),
        createData('Brides4love', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        createData('LoveIn Chat', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        
        createData('Charmlive', 5.7, 38, 68, 120, '-', '-', '-', '-'),
        createData('Love Temptation', 5.7, 38, 68, 120, 5.7, 38, 68, 120),
        createData('Bride Forever', 5.7, 38, 68, 120, '-', '-', '-', '-'),
    ];
    return (
        <TableContainer component={Paper}>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell align={"center"}></TableCell>
                        <TableCell align={"center"}><b>ЧАТ</b></TableCell>
                        <TableCell  align={"center"}><b>ПИСЬМА</b></TableCell>
                    </TableRow>
                </TableHead>
            </Table>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Сайт</StyledTableCell>
                        <StyledTableCell>1 день</StyledTableCell>
                        <StyledTableCell>7 дней</StyledTableCell>
                        <StyledTableCell>15 дней</StyledTableCell>
                        <StyledTableCell>30 дней</StyledTableCell>
                        <StyledTableCell>1 день</StyledTableCell>
                        <StyledTableCell>7 дней</StyledTableCell>
                        <StyledTableCell>15 дней</StyledTableCell>
                        <StyledTableCell>30 дней</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <StyledTableRow key={row.name}>
                            <StyledTableCell style={{
                                color: '#6495ed',
                                fontSize: '1rem'
                            }}>{row.site}</StyledTableCell>
                            <StyledTableCell>{row.chat1day} </StyledTableCell>
                            <StyledTableCell>{row.chat7day} </StyledTableCell>
                            <StyledTableCell>{row.chat15day}</StyledTableCell>
                            <StyledTableCell>{row.chat30day}</StyledTableCell>
                            <StyledTableCell>{row.mail1day}</StyledTableCell>
                            <StyledTableCell>{row.mail7day}</StyledTableCell>
                            <StyledTableCell>{row.mail15day}</StyledTableCell>
                            <StyledTableCell>{row.mail30day}</StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
            <Typography component={'div'} style={{padding: '15px'}}>
                <ul>
                    <li>Все цены указаны в UAH</li>
                    <li>Стоимость серверкапчи 0.12 UAH за 1 разгадывание</li>
                    <li>Тест 3 дня Вы можете активировать сразу в программе бесплатно (средства за использования серверкапчи будут списаны с вашего баланса, если активировано)</li>
                </ul>
            </Typography>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '40px'
            }}>
                <Button variant={"contained"} href={'https://help-chat.com.ua/stat-agency/download/downloadWindowsBuild'} color={'primary'} style={{color: "white", margin: '40px'}}>
                    Скачать для Windows
                </Button>
                <Button variant={"contained"} href={'https://help-chat.com.ua/stat-agency/download/downloadMacBuild'} color={'primary'} style={{color: "white", margin: '40px'}}>
                    Скачать для Mac
                </Button>
                <Button variant={"contained"} href={'https://chrome.google.com/webstore/detail/improver-of-hc/ljbdocmmfpejofpcldginbilddlifjek?hl=uk'} color={'primary'} style={{color: "white", margin: '40px'}}>
                    Скачать для Chrome
                </Button>
            </div>
        </TableContainer>
    );
}